export const LOG_LEVEL = {
    WARN: 'warning',
    ERROR: 'error'
};

export default class Bugsnag {
    static notify(errorName, errorMessage, metaData=null, severity=LOG_LEVEL.WARNING) {
        if (!window.Bugsnag) {
            const message = `${errorName}: ${errorMessage}`;
            if (severity === LOG_LEVEL.ERROR) {
                console.error(message, metaData);
            } else {
                console.warn(message, metaData);
            }
            return;
        }

        window.Bugsnag.notify(errorName, errorMessage, metaData, severity);
    }
}



// WEBPACK FOOTER //
// ./js/common/utils/Bugsnag.js